import { Chip, ChipProps } from "@mantine/core"
import dayjs from "dayjs"
import { RangePickerMakroProps } from "."

interface Props extends RangePickerMakroProps, ChipProps {
  targetStart: Date
  targetEnd: Date
}

// Usage:
// <DatePickerMakroChip targetStart={someDate} targetEnd={someDate.add(12, "months")} start={start} end={end}>Label</DatePickerMakroChip>
export function DatePickerMakroChip({
  start,
  targetStart,
  end,
  targetEnd,
  setStart,
  setEnd,
  ...props
}: Props) {
  return (
    <Chip
      styles={{
        iconWrapper: {
          display: "none",
        },
        label: {
          padding: "0 var(--mantine-spacing-md)",
        },
      }}
      variant="filled"
      onClick={() => {
        setStart && setStart(targetStart)
        setEnd && setEnd(targetEnd)
      }}
      checked={
        start !== undefined &&
        end !== undefined &&
        dayjs(start).isSame(targetStart, "date") &&
        dayjs(end).isSame(targetEnd, "date")
      }
      {...props}
    />
  )
}
